module.exports = __webpack_public_path__ + "static/img/details.1ac0f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/details.png
// module id = f1nz
// module chunks = 1 3